<template>
	<div id='propiAdd'>
		<h2>AGREGAR PROPIEDAD</h2>

		<a @click="$router.go(-1)">regresar</a>
		<br><br>
		
		<div id='captura'>
			<form v-on:submit.prevent= 'guardarPropiedad'>
				<table align="center">
					<tr>
					   <td>Nombre completo</td>
					   <td><input type="text" name="nombreCompleto" required v-model="propiedades.nombreCompleto"></td>
					<tr>
					<tr>
						<td>Familia</td>
						<td>
          
                            <select  id="familiasSelect" name="dueno" required v-model="propiedades.familia" >
                                <option value=" "  > </option>
                                <option value="OTRO"  >OTRO</option>
                            </select>
                            <div  v-if="propiedades.familia == 'OTRO'">
                                Familia
                                <input id="otroFamilia" required v-model="nuevoFamilia" >
                                    
                                </input>
                            </div>                  
                        </td>
					<tr>
					<tr>
						<td>Subfamilia</td>
						<td><input type="text" name="subfamilia" v-model="propiedades.subfamilia"></td>
					</tr>
					<tr>
						<td>Dueño</td>
						<td>
							<select  id="duenosSelect" name="dueno" required v-model="propiedades.dueno" >
                                <option value=" "  > </option>
                                <option value="OTRO">OTRO</option>
							</select>
                            <div  v-if="propiedades.dueno == 'OTRO'">
                                Dueño nombre 
                                <input id="otroDueno" required v-model="nuevoDueno" >
                                    
                                </input>
                            </div>
						</td>
					</tr>				
					<tr>
						<td>Tipo</td>
						<td>
							<select name="tipo" value="LOCAL" required v-model="propiedades.tipo">
								<option value="LOCAL" selected>LOCAL</option>
	  							<option value="OFICINA">OFICINA</option>
	  							<option value="CASA">CASA</option>
	  							<option value="TERRENO">TERRENO</option>
                                <option value="BODEGA">BODEGA</option>

	  							<option value="OTRO">OTRO</option>

							</select>

						</td>
					</tr>
					<tr>
						<td>Clave Catastral</td>
						<td><input type="text" name="claveCatastral"  v-model="propiedades.claveCatastral"></td>
					</tr>

					<tr>					
						<td>Calle</td>
						<td><input type="text" name="dirCalle" required v-model="propiedades.dirCalle"></td>
					</tr>
					<tr>
						<td>Numero</td> 
						<td><input type="text" name="dirNumero" required v-model="propiedades.dirNumero"></td>
					</tr>
					<tr>
						<td>Interior</td>
						<td><input type="text" name="dirInterior" v-model="propiedades.dirInterior"></td>
					</tr>
					<tr>
						<td>Ciudad</td>
						<td>
                            <select  id="ciudadesSelect" name="estado" required v-model="propiedades.dirCiudad" >
                                <option value=" "  > </option>
                                <option value="OTRO">OTRO</option>
                            </select>
                            <div  v-if="propiedades.dirCiudad == 'OTRO'">
                                Ciudad
                                <input id="otroCiudad" required v-model="nuevoCiudad" >
                                    
                                </input>
                            </div>
                        </td>
					</tr>
					<tr>
						<td>Estado</td>
						<td>
                            <select  id="estadosSelect" name="estado" required v-model="propiedades.dirEstado" >
                                <option value=" "  > </option>
                                <option value="OTRO">OTRO</option>
                            </select>
                            <div  v-if="propiedades.dirEstado == 'OTRO'">
                                Nombre estado 
                                <input id="otroEstado" required v-model="nuevoEstado" >
                                </input>
                            </div>
                         </td>              

					</tr>
                    <tr>
                        <td>Pais</td>
                        <td><input type="text"  name="pais" value="Mexico" required  v-model="propiedades.pais"></td>
                    </tr>                    
					<tr>
						<td>Codigo</td>
						<td><input type="text" name="dirCodigo" v-model="propiedades.dirCodigo"></td>
					</tr>
						<td>Metros cuadrados</td>
						<td><input type="text" name="metrosCuadrados" required v-model="propiedades.metrosCuadrados"></td>
					</tr>
					<tr>
						<td>Medidas y colindancias</td>
						<td><input type="text" name="metrosCuadrados" required v-model="propiedades.medidasYcol"></td>
					</tr>
				</table>
				<br>
				<input type="submit" name="agregandoPropiedad">
			</form>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'agrega-propiedad',
			mounted(){
				this.valida();
                this.leeDatosSelects();
			},
  			props: ['vector', 'elusuario', 'empresa'],  
			data(){
				return {
					propiedades:{
						nombreCompleto:'',
						familia:'',
						subfamilia:'',
						dueno: '',
						tipo:'',
						claveCatastral:'',
						pais:'',
						dirCalle:'',
						dirNumero:'',
						dirInterior:'',
						dirCiudad:'',
						dirEstado:'',
						dirCodigo:'',
						metrosCuadrados:'',
						status:'',
						fechaModifica:'',
						quienModifico:'',
						medidasYcol:''
					},
                    duenosPropiedades:{
                        dueno:'',
                        
                    },
                    ciudadesPropiedades:{
                        dirCiudad:'',
                        
                    },
                    estadosPropiedades:{
                        dirEstado:'',
                        
                    },
                    familiasPropiedades:{
                        familia:'',                        
                    },                    
                    nuevoDueno:'',
                    nuevoEstado:'',
                    nuevoCiudad:'',
                    nuevoFamilia:''
				};
			},
			methods:{
				valida(){
		  			if(!this.vector.includes('MASTERGGUV')){
						if(! this.vector.includes('Propiedades Altas')){
							alert('Seccion no autorizada');
							document.getElementById('captura').hidden = true;
						}
					}
				},
				guardarPropiedad(){
					var propiedades1= this.propiedades;
					var router= this.$router;
					propiedades1.fechaModifica = this.fechaActual();

					propiedades1.quienModifico = this.elusuario;

                    if (propiedades1.dueno = 'OTRO') propiedades1.dueno = this.nuevoDueno;
                    if (propiedades1.dirCiudad = 'OTRO') propiedades1.dirCiudad = this.nuevoCiudad;
                    if (propiedades1.dirEstado = 'OTRO') propiedades1.dirEstado = this.nuevoEstado;

					axios.post('https://www.directodo.com/Rentus/accesosdb/agregaPropiedad.php?emp='+ this.empresa + '&nombreCompleto='+propiedades1.nombreCompleto+'&familia='+propiedades1.familia+'&subfamilia='+propiedades1.subfamilia+'&dueno='+propiedades1.dueno+'&tipo='+propiedades1.tipo+'&claveCatastral='+propiedades1.claveCatastral+'&pais='+propiedades1.pais+'&dirCalle='+propiedades1.dirCalle+'&dirNumero='+propiedades1.dirNumero+'&dirInterior='+propiedades1.dirInterior+'&dirCiudad='+propiedades1.dirCiudad+'&dirEstado='+propiedades1.dirEstado+'&dirCodigo='+propiedades1.dirCodigo+'&metrosCuadrados='+propiedades1.metrosCuadrados+'&status=DISPONIBLE'+'&fechaModifica='+propiedades1.fechaModifica+'&quienModifico='+propiedades1.quienModifico+'&medidasYcol='+propiedades1.medidasYcol)
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
                                    alert('Propiedad agregada satisfactoriamente');
		  		          			router.push('/pro')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
				},

				fechaActual(){      
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;    
				},
                leeDatosSelects(){
                    axios.get('https://www.directodo.com/Rentus/accesosdb/leeDuenosPropiedades.php?cuale=' + this.empresa)
                         .then((respuesta) => {
                            this.duenosPropiedades=respuesta.data;
                            
                            var selector = document.getElementById("duenosSelect");

                            for (let x in this.duenosPropiedades) { // agrega los duenos al select
                                selector.add(new Option(this.duenosPropiedades[x].dueno,this.duenosPropiedades[x].dueno ));
                            }

                         });

                    axios.get('https://www.directodo.com/Rentus/accesosdb/leeCiudadesPropiedades.php?cuale=' + this.empresa)
                         .then((respuesta) => {
                            this.ciudadesPropiedades=respuesta.data;
                            
                            var selector = document.getElementById("ciudadesSelect");

                            for (let x in this.ciudadesPropiedades) { // agrega los duenos al select
                                selector.add(new Option(this.ciudadesPropiedades[x].dirCiudad,this.ciudadesPropiedades[x].dirCiudad ));
                            }

                         });

                    axios.get('https://www.directodo.com/Rentus/accesosdb/leeEstadosPropiedades.php?cuale=' + this.empresa)
                         .then((respuesta) => {
                            this.estadosPropiedades=respuesta.data;
                            
                            var selector = document.getElementById("estadosSelect");

                            for (let x in this.estadosPropiedades) { // agrega los duenos al select
                                selector.add(new Option(this.estadosPropiedades[x].dirEstado,this.estadosPropiedades[x].dirEstado ));
                            }

                         });

                    axios.get('https://www.directodo.com/Rentus/accesosdb/leeFamiliasPropiedades.php?cuale=' + this.empresa)
                         .then((respuesta) => {
                            this.leeFamiliasPropiedades=respuesta.data;
                            
                            var selector = document.getElementById("familiasSelect");

                            for (let x in this.leeFamiliasPropiedades) { // agrega los duenos al select
                                selector.add(new Option(this.leeFamiliasPropiedades[x].familia,this.leeFamiliasPropiedades[x].familia ));
                            }

                         });                         

                }
			}
	}
</script>

<style lang="scss">
	#propiAdd{
		padding:20px;
		li{
			width: 20%;
			height: 100px;
			background: #eee;
			overflow: hidden;
		}
	}
</style>


// WEBPACK FOOTER //
// src/Propiedad-agregar.vue